import * as React from 'react';

interface ExitPromptContextType {
    isFormDirty: boolean;
    setFormDirty: (isFormDirty: boolean) => void;
    isExitModalOpen: boolean;
    setExitModalOpen: (isExitModalOpen: boolean) => void;
    exitModalAction: string;
    setExitModalAction: (exitModalAction: string) => void;
}

export const ExitPromptContext = React.createContext<ExitPromptContextType>({
    isFormDirty: false,
    setFormDirty: () => {},
    isExitModalOpen: false,
    setExitModalOpen: () => {},
    exitModalAction: '',
    setExitModalAction: () => {}
});